import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-casino',
  template: `
  <app-m-casino *ngIf="env.isMobile"></app-m-casino>
  <app-d-casino *ngIf="!env.isMobile"></app-d-casino>
  `,
  styles: []
})
export class CasinoComponent extends BaseClass<any> implements OnInit {
  @ViewChild('parentTabs', { static: false }) parentTabs?: TabsetComponent;
  @ViewChild('childTabs', { static: false }) childTabs?: TabsetComponent;
  public key: any;
  public checkKey: boolean = false;

  public data: any;
  public id: any;

  constructor(public service: WebserviceService, public router: Router, protected actRoute: ActivatedRoute, public _common: CommonService
  ) {
    super(document);

    this.id = Number(this.actRoute.snapshot.paramMap.get('id'));

    this.actRoute.queryParams.subscribe(params => {
      this.key = params['name']
    });
  }

  ngOnInit(): void {
    this.getUserData();
  }

  tabId = 0;
  onSelect(id: any): void {
    this.tabId = id;
  }
  pTabId = 0;
  onSelectParent(id: any): void {
    this.pTabId = id;
    if (this.parentTabs?.tabs[id]) {
      this.parentTabs.tabs[id].active = true;
    }
    this.onSelect(0);
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getUserData() {
    if (this.isLogin()) {
      this.userData = this.getLocalItem('user');
      this.webSocketUrl = this.getLocalItem('ws', false);
      if (this.webSocketUrl) {
        this.getServices().Get(`${this.webSocketUrl + this.api.userData}/${this.userData?.id}`).subscribe(
          (res) => {
            if (res) {
              this.userData.balance = res.balance;
              this.userData.pl = res.pl;
              this.userData.available_balance = parseFloat(res.pl) + parseFloat(res.balance) + parseFloat(res.expose);
              this.userData.expose = res.expose;
              this.setLocalItem('user', this.userData);
              this.userData = this.getLocalItem('user');
            }
          },
          (err) => {
            console.log(err);
          });
      }
    }
  }

  getData() {
    this.pTabId = 0;
    this.tabId = 0;
    this.isLoad = true;
    let api = '';
    if (this.isLogin()) {
      api = this.events.casino1.includes(this.id) ? this.api.casino1 : this.events.iCasino.includes(this.id) ? this.api.casinoIList : this.events.intCasino.includes(this.id) ? this.api.casinoIntList : '';
    } else {
      api = this.events.casino1.includes(this.id) ? this.api.casino1G : this.events.iCasino.includes(this.id) ? this.api.casinoIListG : this.events.intCasino.includes(this.id) ? this.api.casinoIntListG : '';
    }

    this.getServices().Get(`${this.env.baseUrl + api}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (this.events.casino1.includes(this.id)) {
            this.setCasino1(res);
          } else if (this.events.iCasino.includes(this.id)) {
            this.setICasino(res);

            // this.setIntCasino(res);
          } else if (this.events.intCasino.includes(this.id)) {
            this.setIntCasino(res);
          }


        } else if (res.status == false) {
          // this._message.errmessage(res?.error?.message);
          this.data = []
          this.router.navigate([`${this.env.isMobile ? '/m/home' : '/home'}`])
        }
        this.isLoad = false;
      },
      (err) => {
        this.isLoad = false;
        console.log(err);
      });
  }

  setCasino1(res: any) {
    this.data = res.data;
  }

  setICasino(res: any) {
    let allDt: any[] = [];
    let allDtGameTyes: any[] = [];
    let dt: any[] = [];
    Object.keys(res.data.providers).forEach((key) => {
      let dataDt: any[] = [];
      let allDataDtInner: any[] = [];
      Object.keys(res.data.providers[key]).forEach((key1) => {
        allDataDtInner = [...allDataDtInner, ...res.data.providers[key][key1]];
        allDt = [...allDt, ...res.data.providers[key][key1]];
        dataDt.push({
          'name': key1,
          'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
          'data': res.data.providers[key][key1]
        });
      });
      dataDt.unshift({ name: 'all', slug: 'all', data: allDataDtInner });
      dt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': dataDt
      });
    });
    allDtGameTyes = allDt.map(item => item.game_type);
    const uniqueSet = new Set(allDtGameTyes);
    allDtGameTyes = [...uniqueSet];

    let finalAllDt: any[] = [];
    allDtGameTyes.forEach(element => {
      finalAllDt.push({
        'name': element,
        'slug': element.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': allDt.filter(e => e.game_type == element)
      });
    });

    dt.unshift({ name: 'all', slug: 'all', data: finalAllDt });
    res.data.providers = dt;
    this.data = res.data.providers;

    if (this.key && this.key != null) {
      this.openFilteredTab(this.data)
    }

  }

  setIntCasino(res: any) {

    let allDt: any[] = [];
    Object.keys(res.data.allTables).forEach((key) => {
      allDt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': res.data.allTables[key]
      });
    });

    //console.log(res.data.tables);
    let dt: any[] = [];
    Object.keys(res.data.tables).forEach((key) => {
      let dataDt: any[] = [];
      Object.keys(res.data.tables[key]).forEach((key1) => {
        let dataDtInner: any[] = [];
        let allDataDtInner: any[] = [];
        Object.keys(res.data.tables[key][key1]).forEach((key2) => {
          allDataDtInner = [...allDataDtInner, ...res.data.tables[key][key1][key2]]
          dataDtInner.push({
            'name': key2,
            'slug': key2.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
            'data': res.data.tables[key][key1][key2]
          });
        });
        // console.log(allDataDtInner);
        dataDtInner.unshift({ name: 'all', slug: 'all', data: allDataDtInner });

        dataDt.push({
          'name': key1,
          'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
          'data': dataDtInner
        });
      });
      dt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': dataDt
      });
    });
    res.data.tables = dt;
    this.data = res.data.tables[0]['data'];
    this.data.unshift({ name: 'all', slug: 'all', data: allDt });
    //console.log(this.data);

    if (this.key && this.key != null) {
      this.openFilteredTab(this.data)
    }
  }

  openFilteredTab(data: any) {

    if (data) {
      data.forEach((element: any, i: any) => {
        // element.data.forEach((dt: any, j: any) => {

        if (element.slug.toUpperCase() == this.key.toUpperCase()) {
          this.pTabId = i;
          // this.tabId = j;
          this.checkKey = true;
          this.onSelectParent(i);
        }
        // });
      });
    }
  }

  confirmBox(item: any, name: any) {
    // console.log(item);
    // console.log(name);

    if (this.isLogin()) {
      let msg = `Profit & amp; Loss in iCasino would be ${item?.multiplier} times.It means, if you WIN 1, your Account Statement would be Credited as ${item?.multiplier} and similarly if you LOSE 1, your Account Statement would be Debited as ${item?.multiplier}. <br> Please note(1 Point = ${item?.multiplier} Points) <br> कृपया ध्यान दें(1 अंक = ${item?.multiplier} अंक)`;
      Swal.fire({
        title: 'DO YOU AGREE?',
        html: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I Agree',
        cancelButtonText: 'No, I dont Agree'
      }).then((result) => {
        if (result.value) {
          this.router.navigate([`${this.env.isMobile ? '/m/casino-detail' : '/casino-detail'}`, this.id, item.id]);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      })
      // this.router.navigate([`${this.env.isMobile ? '/m/casino-detail' : '/casino-detail'}`, this.id, item.id]);
    } else {
      this._common.openLogin();
    }
  }

  ngAfterContentChecked() {
    if (this.checkKey == true && this.parentTabs) {
      this.onSelectParent(this.pTabId);
      this.gotoDiv(`goto-casino-${this.pTabId}-link`)
      this.checkKey = false;
    }
  }
}
